import styled from 'styled-components';

export const ClearFilterSVGIcon = styled.svg`
cursor: pointer;
path {
    stroke:var(--primary);
    }
}
`;
